.side-panel{display:grid;grid-auto-flow:row;grid-template-rows:calc(var(--ursa--split-view-toolbar-height) + 2px) calc(100% - (var(--ursa--split-view-toolbar-height) + 2px));background-color:#f2f2f2;height:100%;width:100%;gap:1px}
/*# sourceMappingURL=side-panel.component.css.map */
